/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

import { useDispatch } from 'react-redux';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

// Actions
import { setClose } from 'store/ducks/dialogs/actions';

import useStyles from './dialogContentYesOrNo.styles';

type DialogContentYesOrNoProps = {
  title?: string;
  image?: string;
  icon?: React.ReactNode;
  yesOnClick: () => void;
  noOnClick?: () => void;
  message?: string | React.ReactElement;
  classes?: {
    image?: string;
  };
};

const DialogContentYesOrNo: React.FunctionComponent<DialogContentYesOrNoProps> = ({
  title,
  image,
  icon,
  message,
  yesOnClick,
  noOnClick,
  classes,
}) => {
  const {
    title: stylesTitle,
    containerImage,
    image: stylesImage,
    message: stylesMessage,
    containerButtons,
  } = useStyles();
  const dispatch = useDispatch();

  const executeYesOnClick = () => {
    dispatch(setClose());
    return yesOnClick();
  };

  const executeNoOnClick = () => {
    if (noOnClick) {
      return noOnClick();
    }

    return dispatch(setClose());
  };

  return (
    <>
      <Typography className={stylesTitle} variant='h6'>
        {title}
      </Typography>
      {image && (
        <Box className={containerImage}>
          <img
            alt='Imagem'
            className={[stylesImage, classes?.image].join(' ')}
            src={image}
          />
        </Box>
      )}
      {icon && <Box className={containerImage}>{icon}</Box>}

      {message && React.isValidElement(message) ? (
        <>{message}</>
      ) : (
        <Typography className={stylesMessage} variant='body1'>
          {message}
        </Typography>
      )}
      <Grid
        alignItems='center'
        className={containerButtons}
        container
        direction='row'
        justifyContent='center'
        spacing={2}>
        <Grid item>
          <Button
            color='primary'
            onClick={executeYesOnClick}
            variant='contained'>
            sim
          </Button>
        </Grid>
        <Grid item>
          <Button color='primary' onClick={executeNoOnClick} variant='outlined'>
            não
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default DialogContentYesOrNo;
export { DialogContentYesOrNo };
